/**
 * Options for select / ButtonGroup
 */

const options = {};

options.contentType = [
  { label: "Paragraph", value: "paragraph" },
  { label: "List", value: "list" }
];

options.listType = [{ label: "ul", value: "UL" }, { label: "ol", value: "OL" }];

export default options;



// WEBPACK FOOTER //
// ./src/data/options.js